const CryptoJS = require("crypto-js");

export function hashUser(label: string) {
 const hash = CryptoJS.SHA256(label);
 const texthash = hash.toString(CryptoJS.enc.Hex);
 return texthash;
}